import { render } from "./TheAposLoginHeader.vue?vue&type=template&id=454caf34&scoped=true"
import script from "./TheAposLoginHeader.vue?vue&type=script&lang=js"
export * from "./TheAposLoginHeader.vue?vue&type=script&lang=js"

import "./TheAposLoginHeader.vue?vue&type=style&index=0&id=454caf34&scoped=true&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454caf34"],['__file',"login/ui/apos/components/TheAposLoginHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "454caf34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('454caf34', __exports__)) {
    api.reload('454caf34', __exports__)
  }
  
  module.hot.accept("./TheAposLoginHeader.vue?vue&type=template&id=454caf34&scoped=true", () => {
    api.rerender('454caf34', render)
  })

}


export default __exports__